import { render } from "./Suscripcion_SuscripcionAud.vue?vue&type=template&id=420fed7c"
import script from "./Suscripcion_SuscripcionAud.vue?vue&type=script&lang=js"
export * from "./Suscripcion_SuscripcionAud.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__